/* Atlin Studios Theme JS */
(function () {
  'use strict';

  /* ── HEADER SCROLL ── */
  var header = document.getElementById('site-header');
  var annBar = document.getElementById('announcement-bar');

  function setHeaderOffset() {
    if (!header) return;
    var offset = annBar ? annBar.offsetHeight : 0;
    header.style.top = offset + 'px';
  }

  if (header) {
    setHeaderOffset();
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ── LOGO INVERSION — white over image sections, dark everywhere else ── */
  var darkSections = document.querySelectorAll('[data-invert-header]');
  if (darkSections.length && header) {
    var activeDark = new Set();
    var darkObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activeDark.add(entry.target);
        } else {
          activeDark.delete(entry.target);
        }
        header.classList.toggle('site-header--light', activeDark.size > 0);
      });
    }, { rootMargin: '0px 0px -85% 0px', threshold: 0 });
    darkSections.forEach(function (el) { darkObserver.observe(el); });
  }

  /* ── MOBILE MENU ── */
  var menuToggle = document.getElementById('menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('open');
      menuToggle.classList.toggle('open', isOpen);
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        menuToggle.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── CART DRAWER ── */
  var cartDrawer  = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');
  var cartToggle  = document.getElementById('cart-toggle');
  var cartClose   = document.getElementById('cart-close');
  var cartItems   = document.getElementById('cart-drawer-items');
  var cartSubtotal = document.getElementById('cart-subtotal');
  var cartCount   = document.getElementById('cart-count');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartToggle)  cartToggle.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {});
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function renderCart(cart) {
    if (!cartItems) return;

    if (cartCount) {
      cartCount.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
      cartCount.classList.toggle('hidden', cart.item_count === 0);
    }
    if (cartSubtotal) {
      cartSubtotal.textContent = formatMoney(cart.total_price);
    }

    if (cart.items.length === 0) {
      cartItems.innerHTML = '<div class="cart-drawer-empty">Your bag is empty.</div>';
      return;
    }

    cartItems.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy">'
        : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cart-drawer-variant">' + item.variant_title + '</div>'
        : '';
      return (
        '<div class="cart-drawer-item">' +
          '<div class="cart-drawer-img">' + img + '</div>' +
          '<div class="cart-drawer-details">' +
            '<div class="cart-drawer-name">' + item.product_title + '</div>' +
            variant +
            '<div class="cart-drawer-price">' + formatMoney(item.final_price) + '</div>' +
            '<button class="cart-drawer-remove" data-key="' + item.key + '">Remove</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    cartItems.querySelectorAll('.cart-drawer-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeItem(btn.getAttribute('data-key'));
      });
    });
  }

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () { fetchCart(); }).catch(function () {});
  }

  /* ── ADD TO CART ── */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = productForm.querySelector('[data-add-to-cart]');
      var variantId = productForm.querySelector('[name="id"]');
      var qty = productForm.querySelector('[name="quantity"]');
      if (!variantId || !variantId.value) {
        showToast('Please select options');
        return;
      }
      var originalText = btn.textContent;
      btn.textContent = '—';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId.value,
          quantity: parseInt(qty ? qty.value : 1) || 1
        })
      }).then(function (res) {
        if (res.ok) {
          btn.textContent = 'Added';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
          openCart();
        } else {
          throw new Error('Failed');
        }
      }).catch(function () {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = originalText; }, 2000);
      });
    });
  }

  /* ── STICKY ADD TO CART ── */
  var stickyBar = document.getElementById('product-sticky-atc');
  var stickyBtn = document.getElementById('sticky-atc-btn');
  var mainAtcBtn = document.getElementById('main-atc-btn');

  if (stickyBar && mainAtcBtn) {
    var atcObserver = new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting;
      stickyBar.classList.toggle('visible', visible);
      stickyBar.setAttribute('aria-hidden', String(!visible));
    }, { threshold: 0 });
    atcObserver.observe(mainAtcBtn);
  }

  if (stickyBtn && productForm) {
    stickyBtn.addEventListener('click', function () {
      productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  /* ── VARIANT SELECTION ── */
  var productDataEl = document.querySelector('[data-product-json]');
  var productData = null;
  if (productDataEl) {
    try { productData = JSON.parse(productDataEl.textContent); } catch (e) {}
  }

  function getSelectedOptions() {
    var opts = {};
    document.querySelectorAll('[data-variant-input].active, [data-variant-input]:checked')
      .forEach(function (el) {
        opts[el.getAttribute('data-option-name')] =
          el.getAttribute('data-option-value') || el.value;
      });
    return opts;
  }

  function findVariant(options) {
    if (!productData) return null;
    return productData.variants.find(function (v) {
      return productData.options.every(function (opt, i) {
        return options[opt] === v.options[i];
      });
    });
  }

  function scrollToVariantImage(variant) {
    if (!variant || !variant.featured_image) return;
    /* position is 1-based */
    var idx = variant.featured_image.position - 1;
    var imgs = document.querySelectorAll('.product-img');
    if (imgs[idx]) {
      var headerH = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-h')
      ) || 72;
      var top = imgs[idx].getBoundingClientRect().top + window.scrollY - headerH;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  function updateVariant() {
    var options = getSelectedOptions();
    var variant = findVariant(options);
    if (!variant) return;

    var idInput = document.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn  = document.querySelector('[data-add-to-cart]');

    if (idInput)  idInput.value = variant.id;
    if (priceEl)  priceEl.textContent = formatMoney(variant.price);
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';
    }
    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';
    }

    scrollToVariantImage(variant);
  }

  function syncStickySizes(optionName, value) {
    document.querySelectorAll(
      '.sticky-size-btn[data-option-name="' + optionName + '"]'
    ).forEach(function (b) { b.classList.remove('active'); });
    var match = document.querySelector(
      '.sticky-size-btn[data-option-name="' + optionName + '"][data-sticky-size="' + value + '"]'
    );
    if (match) match.classList.add('active');
  }

  document.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (this.disabled) return;
      var group = this.closest('.size-options');
      if (group) {
        group.querySelectorAll('.size-btn').forEach(function (b) {
          b.classList.remove('active');
        });
      }
      this.classList.add('active');
      syncStickySizes(
        this.getAttribute('data-option-name'),
        this.getAttribute('data-option-value')
      );
      updateVariant();
    });
  });

  /* Sticky size buttons — click mirrors the main product form */
  document.querySelectorAll('.sticky-size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (this.disabled) return;
      var optionName = this.getAttribute('data-option-name');
      var value = this.getAttribute('data-sticky-size');
      /* Trigger the main form button so variant logic stays in one place */
      var mainBtn = document.querySelector(
        '.size-btn[data-option-name="' + optionName + '"][data-option-value="' + value + '"]'
      );
      if (mainBtn && !mainBtn.disabled) mainBtn.click();
    });
  });

  document.querySelectorAll('.color-swatch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var group = this.closest('.color-swatches');
      if (group) {
        group.querySelectorAll('.color-swatch').forEach(function (s) {
          s.classList.remove('active');
        });
      }
      this.classList.add('active');
      updateVariant();
    });
  });

  /* ── ACCORDION ── */
  document.querySelectorAll('.accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = this.closest('.accordion-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item.open').forEach(function (i) {
        i.classList.remove('open');
      });
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── QUANTITY ── */
  document.querySelectorAll('.quantity-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.closest('.quantity-wrapper').querySelector('.quantity-input');
      var current = parseInt(input.value) || 1;
      var delta = this.getAttribute('data-action') === 'plus' ? 1 : -1;
      input.value = Math.max(1, current + delta);
    });
  });

  /* ── MODAL ── */
  document.querySelectorAll('[data-modal-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-modal-open'));
      if (target) target.classList.add('open');
    });
  });
  document.querySelectorAll('[data-modal-close], .modal-overlay').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (e.target === el) {
        document.querySelectorAll('.modal-overlay.open').forEach(function (m) {
          m.classList.remove('open');
        });
      }
    });
  });

  /* ── TOAST ── */
  function showToast(msg) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, 2500);
  }

  /* ── INIT CART COUNT ── */
  fetchCart();

  /* ── PAGE LOADED — hero fade-in ── */
  requestAnimationFrame(function () {
    document.body.classList.add('page-loaded');
  });

  /* ── SCROLL REVEAL ── */
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!prefersReducedMotion) {
    var riseObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          riseObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });
    document.querySelectorAll('.rise').forEach(function (el) {
      riseObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.rise').forEach(function (el) {
      el.classList.add('in');
    });
  }

})();
